import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
import Images from 'assets/Images';

export default function Textbox(props) {
	const { id, type, value, placeholder, onChange, disabled, required, infoContent, mb0, mandatory, maxlength, display, minlength, borderNone, label, last, error, name, errorMessage, onBlur, prefix, prefixValue, suffix, suffixValue } = props;

	const inputElement = (
		<input
			className={classNames({ 'textbox-row__input': true, 'textbox-row--error': error, 'textbox-row--disabled': disabled, borderNone })}
			id={id}
			type={type}
			value={value}
			name={name}
			placeholder={placeholder}
			disabled={disabled}
			required={required}
			maxLength={maxlength}
			minLength={minlength}
			last={last}
			onChange={onChange}
			onBlur={onBlur}
			autoComplete='off'
		/>
	);

	const displayField = (
		<div className='textbox-row__display'>
			<h5>{label}</h5>
			<span className='textbox-row__value'>{value || '-'}</span>
		</div>
	);

	return (
		<>
			{display ? (
				displayField
			) : (
				<div className={classNames({ 'textbox-row': true, mb0 })}>
					{label && (
						<label>
							{label} {mandatory && <sup>*</sup>}
							{infoContent && (
								<div className='textbox-row__helpContainer'>
									<div className='textbox-row__help'>
										<img src={Images.help} />
									</div>
									<div className='textbox-row__helpContent'>{infoContent}</div>
								</div>
							)}
						</label>
					)}
					{prefix && (
						<div className='textbox-row__prefix'>
							<div className={classNames({ 'textbox-row__prefix-value': true, 'textbox-row__container': true, 'textbox-row--error': error, 'textbox-row--success': !error })}>{prefixValue}</div>
							{inputElement}
						</div>
					)}
					{suffix && (
						<div className='textbox-row__suffix'>
							{inputElement}
							<div className={classNames({ 'textbox-row__suffix-value': true, 'textbox-row__container': true, 'textbox-row--error': error, 'textbox-row--success': !error })}>{suffixValue}</div>
						</div>
					)}
					{!prefix && !suffix && inputElement}
					{error && <div className='textbox-row__error'>{errorMessage}</div>}
				</div>
			)}
		</>
	);
}

Textbox.propTypes = {
	id: PropTypes.string,
	type: PropTypes.string,
	value: PropTypes.any,
	placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	mandatory: PropTypes.bool,
	minlength: PropTypes.number,
	maxlength: PropTypes.number,
	label: PropTypes.string,
	errorMessage: PropTypes.string,
	last: PropTypes.bool,
	error: PropTypes.bool,
	name: PropTypes.string,
	required: PropTypes.bool,
	display: PropTypes.bool,
	onChange: PropTypes.func,
	prefix: PropTypes.any,
	prefixValue: PropTypes.any
};

Textbox.defaultProps = {
	id: null,
	type: 'text',
	value: '',
	last: null,
	error: null,
	label: '',
	mandatory: false,
	placeholder: '',
	disabled: false,
	maxlength: 1800,
	minlength: 0,
	name: '',
	prefix: false,
	prefixValue: '',
	required: false,
	display: false,
	onChange: () => {}
};
